export default function StatCard({
  title,
  value,
  icon,
  color = "primary",
  subtitle,
  onClick,
}) {
  const colorClasses = {
    primary: "from-primary to-primary/80",
    secondary: "from-secondary to-secondary/80",
    accent: "from-accent to-accent/80",
  };

  const gradientClass = colorClasses[color] || colorClasses.primary;

  return (
    <div
      className={`bg-gradient-to-br ${gradientClass} rounded-xl shadow-lg p-6 ${
        onClick ? "cursor-pointer hover:shadow-xl transition-shadow" : ""
      }`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium">{title}</p>
          <p className="text-3xl font-bold mt-2">{value}</p>
          {subtitle && <p className="text-xs mt-1">{subtitle}</p>}
        </div>
        {icon && <div className="">{icon}</div>}
      </div>
    </div>
  );
}
